import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Button } from '../components/ui/button';
import { Users, Briefcase, UserCheck, GraduationCap, Target } from 'lucide-react';
import ConsultationModal from '../components/ConsultationModal';

const WHATSAPP_URL = 'https://wa.me/916366979916?text=Hi%20CloudXAI%2C%20I%20am%20interested%20in%20Recruitment%20services';

const RecruitmentPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0B0F1A]">
      <Header />
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} serviceType="Recruitment" />
      
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #0B0F1A 0%, #020617 100%)'}}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{backgroundImage: 'linear-gradient(#00E5FF 1px, transparent 1px), linear-gradient(90deg, #00E5FF 1px, transparent 1px)', backgroundSize: '50px 50px'}}></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <Link to="/" className="inline-flex items-center text-[#00E5FF] hover:text-[#1DE9B6] mb-8 transition-colors">← Back to Home</Link>
          
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center shadow-xl shadow-[#00E5FF]/50">
              <Users className="w-8 h-8 text-[#0B0F1A]" />
            </div>
            <h1 className="text-4xl lg:text-6xl font-bold text-white font-['Space_Grotesk']">Recruitment & Talent Solutions</h1>
          </div>
          <div className="w-32 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mb-6"></div>
          <p className="text-xl text-[#9CA3AF] max-w-4xl">Job-ready IT & Non-IT talent for organizations</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#111827]">
        <div className="max-w-7xl mx-auto space-y-16">
          
          {/* IT Recruitment */}
          <div className="bg-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-8">
            <div className="flex items-start space-x-6 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center">
                <Users className="w-7 h-7 text-[#0B0F1A]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">IT Recruitment</h2>
                <p className="text-[#9CA3AF] text-lg mb-6">We specialize in hiring skilled IT professionals across modern and emerging technologies.</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#00E5FF] font-semibold mb-4">Roles We Hire For:</h4>
              <div className="grid md:grid-cols-2 gap-3">
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Cloud Engineers</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Software Developers</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Data & AI Professionals</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Cyber Security Specialists</span></div>
              </div>
              <p className="text-[#38BDF8] text-sm mt-4 italic">Our screening process ensures candidates are technically strong and role-ready.</p>
            </div>
          </div>

          {/* Non-IT Recruitment */}
          <div className="bg-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-8">
            <div className="flex items-start space-x-6 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center">
                <Briefcase className="w-7 h-7 text-[#0B0F1A]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">Non-IT Recruitment</h2>
                <p className="text-[#9CA3AF] text-lg mb-6">We support organizations with Non-IT hiring needs across business and operational roles.</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#00E5FF] font-semibold mb-4">Key Roles:</h4>
              <div className="grid md:grid-cols-2 gap-3">
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">HR & Operations</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Sales & Marketing</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Customer Support</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Administrative Functions</span></div>
              </div>
            </div>
          </div>

          {/* Staffing Services */}
          <div className="bg-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-8">
            <div className="flex items-start space-x-6 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center">
                <UserCheck className="w-7 h-7 text-[#0B0F1A]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">Staffing Services</h2>
                <p className="text-[#9CA3AF] text-lg mb-6">Flexible staffing solutions designed to meet short-term and long-term business needs.</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#00E5FF] font-semibold mb-4">Staffing Models:</h4>
              <div className="space-y-2">
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Contract Staffing</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Permanent Staffing</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Contract-to-Hire (C2H)</span></div>
              </div>
            </div>
          </div>

          {/* Campus Hiring */}
          <div className="bg-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-8">
            <div className="flex items-start space-x-6 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center">
                <GraduationCap className="w-7 h-7 text-[#0B0F1A]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">Campus Hiring Programs</h2>
                <p className="text-[#9CA3AF] text-lg mb-6">We partner with colleges and institutions to deliver structured campus hiring solutions.</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#00E5FF] font-semibold mb-4">Program Highlights:</h4>
              <div className="space-y-2">
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Fresher hiring drives</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Skill assessment & screening</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Industry-aligned talent pipelines</span></div>
              </div>
            </div>
          </div>

          {/* Skill-Based Screening */}
          <div className="bg-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-8">
            <div className="flex items-start space-x-6 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center">
                <Target className="w-7 h-7 text-[#0B0F1A]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">Skill-Based Talent Screening</h2>
                <p className="text-[#9CA3AF] text-lg mb-6">We assess candidates based on skills, behavior, and role alignment.</p>
              </div>
            </div>
            <div>
              <h4 className="text-[#00E5FF] font-semibold mb-4">Screening Includes:</h4>
              <div className="space-y-2">
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Technical assessments</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Behavioral interviews</span></div>
                <div className="flex items-start space-x-2"><div className="w-2 h-2 rounded-full bg-[#00E5FF] mt-2"></div><span className="text-[#9CA3AF]">Role-specific evaluation</span></div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0F1A]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6 font-['Space_Grotesk']">Looking for Talent Solutions?</h2>
          <p className="text-xl text-[#9CA3AF] mb-8">Connect with us to discuss your hiring needs</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={() => setIsModalOpen(true)} className="bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-semibold px-8 py-6 text-lg rounded-lg shadow-lg shadow-[#00E5FF]/40 transition-all duration-300">Request Consultation</Button>
            <Button onClick={() => window.open(WHATSAPP_URL, '_blank')} className="border-2 border-[#00E5FF] text-[#00E5FF] hover:bg-[#00E5FF]/10 px-8 py-6 text-lg rounded-lg transition-all duration-300 bg-transparent">Talk to Our Experts</Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default RecruitmentPage;
